<template>
  <div data-role="qc-pagination" class="tc-15-page">
    <!-- 分页器状态 -->
    <div class="tc-15-page-state">
      <span class="tc-15-page-text">
        <template>
          {{$t('cos.selected_items')}}<strong>{{ selectedNum }}</strong>{{$t('cos.items')}}
          <span>
            {{$t('cos.pulled_items')}} <strong>{{totalNum}}</strong> {{$t('cos.items')}}
          </span>
        </template>

      </span>
    </div>
    <div class="tc-15-page-operate">
      <span class="tc-15-page-text">{{$t('cos.rows_per_page')}}</span>
      <!-- 页数大小选择 -->
      <div :class="{ 'tc-15-page-selected': innerShow }" class="tc-15-page-select" v-click-outside="onClickOutside">
        <qc-button type="text" class="indent" style="line-height: 1" @click="onClickTrigger">
          {{ innerPageSize }}
          <span class="ico-arrow" />
        </qc-button>
        <ul v-if="innerShow" class="tc-15-simulate-option tc-15-def-scroll">
          <li v-for="pageSizeOption in pageSizeOptions" :key="pageSizeOption" @click="onSelectPageSize(pageSizeOption)">
            {{ pageSizeOption }}</li>
        </ul>
      </div>
      <!-- 选项前一页 -->
      <qc-button :class="{'disable': disableBackward }" :disabled="disableBackward"
        :title="$t('cos.previous_page')" class="tc-15-page-pre" type="text"
        @click="onSelectPage(innerCurrPage - 1)" />
      <!--  页码选择 -->
      <div class="tc-15-page-select">
        <a class="tc-15-page-num" href="javascript:;">{{$t('cos.page')}} {{innerCurrPage}} {{$t('cos.page_number')}}</a>
      </div>
      <!-- 选项后一页 -->
      <qc-button :class="{'disable': disableForward}" :disabled="disableForward" :title="$t('cos.next_page')"
        class="tc-15-page-next" type="text" @click="onSelectPage(innerCurrPage + 1)" />
    </div>
  </div>
</template>

<script>
import clickOutside from '@/scripts/directives/clickOutside';

export default {
  directives: {
    clickOutside,
  },
  props: {
    /**
     * 总数
     */
    totalNum: {
      type: Number,
      default: 0,
    },
    /**
     * 当前页码
     */
    currPage: {
      type: Number,
      default: 1,
    },
    /**
     * 每页的条数
     */
    pageSize: {
      type: Number,
      default: 100,
    },
    /**
     * 已选择项数
     */
    selectedNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      innerCurrPage: this.currPage,
      innerShow: false,
      innerPageSize: this.pageSize,
      pageSizeOptions: [50, 100, 200],
    };
  },
  watch: {
    currPage() {
      this.innerCurrPage = this.currPage;
    },
    pageSize() {
      this.innerPageSize = this.pageSize;
      console.log('pageSize -> this.pageSize', this.pageSize);
    },
  },
  computed: {
    lastPage() {
      return Math.ceil(this.totalNum / this.innerPageSize);
    },
    disableBackward() {
      return this.innerCurrPage <= 1;
    },
    disableForward() {
      return this.innerCurrPage >= this.lastPage;
    },
    /**
     * 用于拦截对 innerCurrPage 的改变并触发事件的代理
     */
    innerCurrPageProxy: {
      get() {
        return this.innerCurrPage;
      },
      set(currPage) {
        if (currPage !== this.innerCurrPage) {
          this.innerCurrPage = currPage;
          /**
           * 统一改动事件
           * @event change
           */
          this.$emit('change', { currPage, pageSize: this.innerPageSize });
        }
      },
    },
    /**
     * 用于拦截对 pageSize 的改变并触发事件的代理
     */
    innerPageSizeProxy: {
      get() {
        return this.innerPageSize;
      },
      set(pageSize) {
        if (pageSize !== this.innerPageSize) {
          this.innerPageSize = pageSize;
          // 每页显示数量改变时，计算一个合适的 currPage
          const properCurrPage = this.getProperCurrPage(
            this.totalNum,
            pageSize,
            this.innerCurrPage,
          );

          // 直接改动 innerCurrPage, 不触发事件
          this.innerCurrPage = properCurrPage;
          /**
           * 统一改动事件
           * @event change
           */
          this.$emit('change', { currPage: properCurrPage, pageSize });
        }
      },
    },
  },
  methods: {
    /**
     * 计算合适的 currPage
     * @param {number} totalNum
     * @param {number} pageSize
     * @param {number} currPage
     */
    getProperCurrPage(totalNum, pageSize, currPage) {
      // 下界为 1
      // 上界为 totalNum / pageSize
      return Math.max(Math.min(Math.ceil(totalNum / pageSize), currPage), 1);
    },
    onSelectPage(currPage) {
      this.innerCurrPageProxy = currPage;
    },
    onClickTrigger() {
      this.innerShow = true;
    },
    onClickOutside() {
      if (this.innerShow) this.innerShow = false;
    },
    onSelectPageSize(pageSize) {
      this.innerPageSizeProxy = pageSize;
      this.innerShow = false;
    },
  },
};
</script>

<style scoped>
.tc-15-page-pre {
  margin-left: 10px;
}
.tc-15-page {
  max-width: unset;
}
</style>
